export default "__VITE_ASSET__CqCwZJay__"